import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { APPLICATION, PAGE } from "utils/constants/models";
import { getAdminContext } from "utils/mapStateToProps";
import { getModelIDFromQuery } from "./route";
import { API_PATHS } from "./paths";

export const useAdminContext = (props) => {
  const router = useRouter();

  const ctxApplicationUUID =
    (props && props.applicationUUID) ||
    getModelIDFromQuery(APPLICATION, router.query);
  const ctxManfiestUUID =
    (props && props.manifestUUID) || getModelIDFromQuery(PAGE, router.query);

  return useSelector((state) =>
    getAdminContext(state, {
      applicationUUID: ctxApplicationUUID,
      manifestUUID: ctxManfiestUUID
    })
  );
};

export const useUserContext = () => {
  return useSelector((state) => state.getIn(["user", "data"]).toJS());
};

/**
 * Append the user uuid on login request so that the state key can match within the exchange
 */
export const useLoginWithStripe = () => {
  const uuid = useSelector((state) => state.getIn(["user", "data", "uuid"]));

  return `${API_PATHS.STRIPE_AUTH}?uuid=${uuid}`;
};
